const updateEstimate = {
    namespaced: true,
}

export default updateEstimate;